import React, { useState, useRef } from 'react';
import ModalContainer from 'design-v2/common/ModalContainer';
import { IPaxInputProps } from './type';
import DropDownHeader from 'design-v2/common/DropDownHeader';
import CoverInput from 'external-components/cover-input';
import { IWidgetTheme, wrapperStyleType } from 'shared-types/index';
import { coverInputVariant } from 'external-components/cover-input/types';
import PreventDoubleClickToZoom from 'design-v2/common/PreventDoubleClickToZoom';

const PaxInput = (props: IPaxInputProps) => {
  const {
    showPaxList,
    cancelButtonHandler,
    saveButtonHandler,
    handleChangePax,
    warningComponent,
    saveAttempted = false,
    isColorOverride = false
  } = props;
  const [localPax, setLocalPax] = useState(props.coversPrefill || 0);

  // localPax is not updated, since closure scope issue
  const latestPax = useRef(localPax)

  const theme = {} as IWidgetTheme;

  const handleOnSave = () => {
    saveButtonHandler(latestPax.current)
  }
  return (
    <>
      <ModalContainer
        closeTimeoutMS={700}
        isOpen={showPaxList}
        onRequestClose={cancelButtonHandler}
        isMaxWidth={false}
        contentStyle={{ width: '350px' }}
      >
        <DropDownHeader
          title={'People'}
          handleCancel={cancelButtonHandler}
          handleSave={async() => {
            // onBlur take 300 ms
            await delay(400)
            handleOnSave()
          }}
          isColorOverride={saveAttempted && isColorOverride}
        />
        {warningComponent}
        <PreventDoubleClickToZoom>
          <CoverInput
            wrapperStyle={wrapperStyleType.standard}
            theme={theme as IWidgetTheme}
            maxPeoplePerBooking={99}
            minPeoplePerBooking={1}
            coversPrefill={localPax}
            variant={coverInputVariant.smallDesignV2}
            hasDelay={false}
            allowMaxBreach={false}
            handleChange={(coversCount) => {
              handleChangePax(coversCount)
              setLocalPax(coversCount);
              latestPax.current = coversCount
            }}
          />
          {props.showStaffName && props.staffNameComponent()}
        </PreventDoubleClickToZoom>
      </ModalContainer>
    </>
  );
};
export default PaxInput;

function delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}